import { ComponentProps } from 'react';
import Row from 'antd/es/row';
import clsx from 'clsx';

interface OpRowProps extends ComponentProps<typeof Row> {
  testId?: string;
}

/**
 * OpRow is a wrapper around Ant Design's Row component.
 * It provides a row container for grid layouts, working in conjunction with OpCol components.
 * 
 * Use this component to create responsive grid layouts with flexible alignment and spacing options.
 * Should contain OpCol components as children.
 * 
 * @example
 * <OpRow gutter={16} justify="center">
 *   <OpCol span={8}>Column 1</OpCol>
 *   <OpCol span={8}>Column 2</OpCol>
 *   <OpCol span={8}>Column 3</OpCol>
 * </OpRow>
 * 
 */
export const OpRow = ({
  className,
  testId = 'op-row',
  ...rowProps
}: OpRowProps) => {
  return (
    <Row
      className={clsx('op-row', className)}
      data-testid={testId}
      {...rowProps}
    />
  );
};
